import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeachToText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSpeachToText"><Path fillRule="evenodd" clipRule="evenodd" d="M7 3V17H5.5V3H7ZM14 4V9.5H12.5V4H14ZM10.5 6V14H9V6H10.5ZM3.5 8V12H2V8H3.5ZM12.5 11H22.5V14.5H21V12.5H18.25V19.5H20V21H15V19.5H16.75V12.5H14V14.5H12.5V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpeachToText;
